/* global axios */
import ApiClient from './ApiClient';

class FollowUpCadenceMediaAssetsAPI extends ApiClient {
  constructor() {
    super('follow-up-cadence-media-assets', { accountScoped: true });
  }

  create(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new FollowUpCadenceMediaAssetsAPI();
